<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 32"
  >
    <title>floor-plan</title>
    <path
      :fill="color"
      d="M11.763 4.267v6.844h-2.281v-6.844h-4.889c-0.18 0-0.326 0.146-0.326 0.326v14.667h5.215v-3.259h2.281v8.148h-2.281v-2.607h-5.215v5.867c0 0.18 0.146 0.326 0.326 0.326h13.037v-5.215h2.281v5.215h7.496c0.18 0 0.326-0.146 0.326-0.326v-15.644h-7.822v5.867h-2.281v-8.148h10.104v-4.889c0-0.18-0.146-0.326-0.326-0.326h-15.644zM11.763 1.333h15.644c1.8 0 3.259 1.459 3.259 3.259v22.815c0 1.8-1.459 3.259-3.259 3.259h-22.815c-1.8 0-3.259-1.459-3.259-3.259v-22.815c0-1.8 1.459-3.259 3.259-3.259h7.17z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgFloorplan',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>
